import React, { ReactElement } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';

// This is a HOC that provides router props and forcibly remounts the component by pathname
// This should only be used to transition pre-existing components with `useState(() => Store.create(...))` patterns
// This is because the `useState` hook will not re-run when the component is rerendered, only when the component is remounted
export function withKeyedRouter<P>(
  Component: React.ComponentType<P>
): React.FC<Omit<P, 'history' | 'match' | 'location'>> {
  return function WithKeyedRouter(
    props: Omit<P, 'history' | 'match' | 'location'>
  ): ReactElement {
    const history = useHistory();
    const match = useRouteMatch();
    const location = useLocation();

    return (
      <Component
        key={location.pathname}
        {...(props as any)}
        history={history}
        match={match}
        location={location}
      />
    );
  };
}

export function withNewRouter<P>(
  Component: React.ComponentType<P>
): React.FC<Omit<P, 'history' | 'match' | 'location'>> {
  return function WithNewRouter(
    props: Omit<P, 'history' | 'match' | 'location'>
  ): ReactElement {
    const history = useHistory();
    const match = useRouteMatch();
    const location = useLocation();

    return (
      <Component
        {...(props as any)}
        history={history}
        match={match}
        location={location}
      />
    );
  };
}

export default withNewRouter;
